export function establishmentsJson (language) {
  let items

  if (language === 'es') {
    items = {
      exportPdf: {
        name: 'exportPdf',
        label: 'exportar establecimientos en formato pdf'
      },
      exportCsv: {
        name: 'exportCsv',
        label: 'exportar establecimientos en formato csv'
      }
    }
  } else if (language === 'en') {
    items = {
      exportPdf: {
        name: 'exportPdf',
        label: 'export establecimientos in PDF format'
      },
      exportCsv: {
        name: 'exportCsv',
        label: 'export establecimientos in CSV format'
      }
    }
  }

  return (items)
}
